import { gsap, ScrollTrigger } from "../gsap.js";

export default function initFloatingScroll() {
  const wrappers = document.querySelectorAll(".floating-scroll");

  if (!wrappers.length) return;

  const navbar = document.querySelector(".navbar-wrapper");

  wrappers.forEach((wrapper) => {
    const track = wrapper.querySelector(".floating-scroll-track");
    if (!track) return;

    const items = track.querySelectorAll(".floating-scroll-item");
    const lastItem = items[items.length - 1];
    if (!lastItem) return;

    function getNavbarHeight() {
      return navbar ? navbar.offsetHeight : 0;
    }

    function getStartOffset() {
      // Start with first item offset to the right for more movement
      const firstItem = items[0];
      const firstItemCenter = firstItem.offsetLeft + firstItem.offsetWidth / 2;
      return wrapper.offsetWidth * 0.65 - firstItemCenter;
    }

    function getScrollDistance() {
      const lastItemCenter = lastItem.offsetLeft + lastItem.offsetWidth / 2;
      const targetPos = wrapper.offsetWidth * 0.75;
      return lastItemCenter - targetPos + getStartOffset();
    }

    gsap.fromTo(
      track,
      { x: () => getStartOffset() },
      {
        x: () => -(getScrollDistance() - getStartOffset()),
        ease: "none",
        scrollTrigger: {
          trigger: wrapper,
          start: () => "top top+=" + getNavbarHeight(),
          end: () => "+=" + getScrollDistance() * 2.5,
          pin: true,
          scrub: 1.5,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onRefreshInit: () => {
            wrapper.style.setProperty(
              "--navbar-height",
              getNavbarHeight() + "px"
            );
          },
        },
      }
    );
  });
}
